import { styled } from '@mui/material/styles'
import { List } from '@mui/material'
import { SupportIcon, BookmarkIcon, SettingsIcon } from '@weblite/icons'
import CallOutlinedIcon from '$common/icons/call-outlined'
import { OpenInNewIcon } from '$common/icons/open-in-new'
import { ProfileActionItem } from '$common/profile-action-item'
import { openSettings } from '$logic/router'
import { getPrivateSpace } from '$logic/private-space'
import { openRoom } from '$logic/opened-room'
import { useClientUser } from '$logic/client-user/react-hook'
import { showHonarioonPhoneMenu } from '$comp/modals/menus/honarioon-phone-menu'
import { t } from '$i18n'

const EXAM_URL = 'https://panel.honarioon.ir/student/dashboard'

export function MyAccountActions() {
  const clientUser = useClientUser()

  const onGoftinoClick = () => {
    analite('PROFILE_GOFTINO_CLICK')
    if (window.Goftino) {
      window.Goftino.setUser({
        name: `${clientUser?.firstname || ''} ${clientUser?.lastname || ''}`.trim(),
        phone: clientUser?.phone || '',
        forceUpdate: true,
      })
      if (clientUser?.id) {
        window.Goftino.setUserId(clientUser.id)
      }
      window.Goftino.open()
    }
  }

  const onPhoneClick = () => {
    analite('PROFILE_PHONE_CLICK')
    showHonarioonPhoneMenu()
  }

  const onExamClick = () => {
    analite('PROFILE_EXAM_CLICK')
    window.open(EXAM_URL, '_blank')
  }

  const onSavedMessageClick = () => {
    openRoom(getPrivateSpace()?.roomId)
    analite('PROFILE_SAVED_CLICK')
  }

  return (
    <StyledList>
      <ProfileActionItem
        iconBgColor="success500"
        Icon={<SupportIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onGoftinoClick}
      >
        {t('myAccount.contactExperts')}
      </ProfileActionItem>

      <ProfileActionItem
        iconBgColor="secondary500"
        Icon={<CallOutlinedIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onPhoneClick}
      >
        {t('myAccount.phoneCall')}
      </ProfileActionItem>

      <ProfileActionItem
        iconBgColor="yellow700"
        Icon={<OpenInNewIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onExamClick}
      >
        {t('myAccount.comprehensiveExam')}
      </ProfileActionItem>

      <ProfileActionItem
        iconBgColor="primary500"
        Icon={<BookmarkIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onSavedMessageClick}
      >
        {t('myAccount.savedMessage')}
      </ProfileActionItem>

      <ProfileActionItem
        iconBgColor="neutral600"
        Icon={<SettingsIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={openSettings}
      >
        {t('common.settings')}
      </ProfileActionItem>
    </StyledList>
  )
}

const StyledList = styled(List)(({ theme }) => ({
  backgroundColor: theme.palette.neutral000,
  boxShadow: theme.shadows[3],
  borderRadius: '12px',
  padding: 0,
  '& > li': {
    overflow: 'hidden',
  },
  '& > li:first-child': {
    borderRadius: '12px 12px 0 0',
  },
  '& > li:last-child': {
    borderRadius: '0 0 12px 12px',
  },
}))
